//messages.js
export default {
    // QUOTES
    quote_id: "Estimate #",
    quoted_by_id: "Prepared By",
    quote_date: "Estimate Date",
    expire_date: "Expire Date",
    line_total: "Line Total",
    subtotal: "Subtotal",
    discount: "Discount",
    total_amount: "Total Amount",
    comments: "Comments",
    edit_quote: "Edit Estimate",
    add_quote: "Add Estimate",
    delete_quote: "Delete Estimate",
    delete_quote_confirm: "This action is not reversible!",
    quotes: "Estimates",
    quote: "Estimate",

    quote_detail_id: "ID",
    cost_price: "Cost Price",
    unit_price: "Unit Price",
    edit_quote_detail: "Edit Detail",
    add_quote_detail: "Add Detail",
    delete_quote_detail: "Delete Detail",
    quote_details: "Quote Details",
};
